import { ISelectItem } from "@/types";
import { ISite } from "@/types/site";
import { Contractor } from "@/models/contractor";
import { User } from "@/models/user";
import { Company } from "@/models/company";

export class Site implements ISite {
  public id = 0;
  public name = "";
  public address = "";
  public span_start = "";
  public span_end = "";
  public is_completion = false;
  public input_completed = false;
  public is_billed = false;
  public contract_price = 0;
  public budget = 0;
  public work_days = 0;
  public company_id = 0;
  public contractor_id = 0;
  public staff_id = 0;
  public created_at = "";
  public updated_at = "";
  public contractor = new Contractor();
  public company = new Company();
  public user = new User();
  public users = [];
  public sales_id = 0;

  public static toSelectItem(site: ISite): ISelectItem {
    return {
      text: site.name,
      value: site.id
    };
  }
}
